import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "gita-chunk-reload-at";
const RELOAD_GUARD_MS = 10_000;

/**
 * After a new deploy, an already-open tab may request page chunks that no longer exist.
 * Reload once to pick up the fresh build; the time guard prevents reload loops.
 * Returns true when a reload was triggered.
 */
export const reloadForStaleChunk = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable: still try a single reload
  }
  window.location.reload();
  return true;
};

export function lazyWithRetry<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      if (reloadForStaleChunk()) {
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
